module.exports = __webpack_public_path__ + "static/p1-f5c63841bd6d376a75d616a1f85caddf.jpg";